<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M82 42V34H18V76H82L84.5 67.5" stroke="black" stroke-width="4"/>
<path d="M18.7097 74L28 42H92L82 76" stroke="black" stroke-width="4"/>
<path d="M18 34H51L46.4167 25H18V34Z" stroke="black" stroke-width="4"/>
</svg>

</template>
